// extracted by mini-css-extract-plugin
export default {"wrap":"oG-z","fullWidth":"pG-z","hideOnDesktop":"qG-z","content":"rG-z","hasOpenedNav":"sG-z","crumbsList":"tG-z","dropdownsWrap":"uG-z"};